import React, { useEffect, useRef } from "react";
import styles from "./comp_css/chapter_15_and_16.module.css";
import Head from "next/head";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import BlockData from "../../../central-doctraine-json/chapter15.json";
import Common_html from "./Common_html";

export default function Chapter_15_and_16_and_17() {

  const router = useRouter()
    const location = useRouter();
    const { pathname } = location;

  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>
      <Head>
        <title>Quantum Mechanics | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content=" Divine Infinite Being, Central Doctrine, Chapter-XV"
        ></meta>
        <meta
          property="og:title"
          content="Quantum Mechanics | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter15_OG_image_15_04-10-2023_v1_new.webp"
        ></meta>
        <meta property="og:image:alt" content="Abstract depiction of quantum mechanics intertwined with divine concepts, featuring quantum particles and cosmic symbols."></meta>
        <meta
          property="og:description"
          content="In the world of quantum mechanics there are many different interpretations for how quantum science works. Here, we will be speaking about two polar opposite, yet highly competitive, interpretations."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=15"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter15_OG_image_15_04-10-2023_v1_new.webp"></meta>
        <meta property="twitter:image:alt" content="Abstract depiction of quantum mechanics intertwined with divine concepts, featuring quantum particles and cosmic symbols."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=15"></meta>
        <meta name="twitter:title" content="Quantum Mechanics | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="In the world of quantum mechanics there are many different interpretations for how quantum science works. Here, we will be speaking about two polar opposite, yet highly competitive, interpretations."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=15" />
      </Head>

       <Common_html BlockData={BlockData} />
    </>
  );
}
